import {
  heptathlonSingleRecord,
  showHeptathlonEventNameType,
  shownHeptathlonDataType,
} from '../../common/types';
import React, { FC, useEffect, useState } from 'react';
import '../../App.css';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
  Button,
  Box,
  Text,
  useDisclosure,
} from '@chakra-ui/react';
import { UpDownIcon } from '@chakra-ui/icons';
import { eventNameDict } from '../functions/eventNameDict';
import { shownResult } from '../functions/shownResult';
import { createHeptathlonShownData } from '../functions/createHeptathlonScoreData';
import {
  calcHeptathlonPoint,
  calcHeptathlonPointToJSX,
} from '../functions/calcHeptathlonPointForResult';
import { explanationButton } from './explanationButton';
import { IntroductionHeptathlonModal } from './IntroductionHeptathlonModal';
import { IntroductionHeptathlonModalEn } from './IntroductionHeptathlonModalEn';
import { shownResultEn } from '../functions/shownResultEn';
import { eventNameDictEn } from '../functions/eventNameDictEn';
import { nameDictEn } from '../functions/nameDictEn';

export const ResultHeptathlonTableEn: FC<{
  Data: heptathlonSingleRecord[];
  rawData: heptathlonSingleRecord[];

  title: string;
  csbData: heptathlonSingleRecord[];
  cpbData: heptathlonSingleRecord[];
  sbData: heptathlonSingleRecord[];
  pbData: heptathlonSingleRecord[];
}> = ({ Data, rawData, title = [], csbData, cpbData, sbData, pbData }) => {
  const [data, setData] = useState(Data);

  const [currentSort, setCurrentSort] =
    useState<showHeptathlonEventNameType>('total');

  const rank = Object.keys(data);

  const [clickName, setClickName] = useState('');

  const showData = data.map((s) => createHeptathlonShownData(s));
  const differenceCsbData = csbData.map((ss) => createHeptathlonShownData(ss));

  const differenceCpbData = cpbData.map((sss) =>
    createHeptathlonShownData(sss)
  );

  const keys = Object.keys(showData[0]) as showHeptathlonEventNameType[];

  const filledProfileNameList = Data.filter((f) => !!f['name']).map(
    (f) => f.name
  );
  // console.log(filledProfileNameList);
  const { isOpen, onOpen, onClose } = useDisclosure();

  //　データを取得した際にソートさせる
  useEffect(() => {
    const showData = Data.map((s) => createHeptathlonShownData(s));
    setData(
      showData.sort((a, b) => {
        return a.total > b.total ? -1 : 1;
      })
    );
  }, [Data]);

  // ソートボタンの実装
  const sortButton = (EventName: showHeptathlonEventNameType) => {
    if (['name'].includes(EventName)) {
      return <>NAME</>;
    }
    return (
      <Button size="xs" onClick={() => handlePointChange(EventName)}>
        {eventNameDictEn(EventName)}
        <UpDownIcon />
      </Button>
    );
  };

  const handlePointChange = (EventName: showHeptathlonEventNameType) => {
    let newData = [...showData];
    setCurrentSort(EventName);
    const sortData = newData.sort((a, b) => {
      return calcHeptathlonPoint(EventName, a[EventName]) >
        calcHeptathlonPoint(EventName, b[EventName])
        ? -1
        : 1;
    });
    setData(sortData);
  };

  const handleNameClick = (sd: shownHeptathlonDataType, NAME: string) => () => {
    setClickName(NAME);
    onOpen();
  };

  return (
    <>
      <IntroductionHeptathlonModalEn
        isOpen={isOpen}
        onClose={onClose}
        todayData={rawData}
        CSB={csbData}
        CPB={cpbData}
        SB={sbData}
        PB={pbData}
        Name={clickName}
      />

      <Box ml="1" fontFamily="monospace" position="relative" zIndex="40">
        {title}　　Swipe records to see more
        {/* 　　　{explanationButton(title)} */}
      </Box>
      <TableContainer>
        <Table size="sm" width="1">
          <TableCaption>HeptathlonResult</TableCaption>
          <Thead>
            <Tr>
              <Th textAlign={'center'}>
                RANK
                <br />
                {/* {eventNameDict(currentSort)} */}
              </Th>
              {keys.map((EvName: showHeptathlonEventNameType, i) => {
                return (
                  <Th key={i} textAlign={'center'}>
                    {sortButton(EvName)}
                  </Th>
                );
              })}
            </Tr>
          </Thead>
          <Tbody>
            {showData.map((sd, i) => {
              // console.log("sd", sd);
              return (
                <Tr key={i}>
                  <Td textAlign={'center'}>{Number(rank[i]) + 1}</Td>
                  <Td textAlign={'center'}>
                    {(() => {
                      // まず辞書から英語表記を取得（無ければそのまま）
                      const enName = nameDictEn[sd.name] || sd.name;

                      // 「名前-国名」に分割
                      const [fullName, country] = enName.split('-');

                      // 「・」で名前を分割（カタカナ対応）
                      const nameParts = fullName.split('・');
                      const firstName = nameParts[0] || '';
                      const lastName = nameParts[1] || '';

                      return (
                        <>
                          {/* ファーストネーム */}
                          <Text
                            fontSize={'9pt'}
                            fontWeight={'bold'}
                            color={'#4169e1'}
                            onClick={handleNameClick(sd, sd.name)}
                          >
                            {firstName}
                          </Text>

                          {/* ラストネーム */}
                          {(filledProfileNameList.includes(sd.name) && (
                            <Text
                              fontSize={'9.5pt'}
                              fontWeight={'bold'}
                              color={'#4169e1'}
                              onClick={handleNameClick(sd, sd.name)}
                            >
                              {lastName}
                            </Text>
                          )) || (
                            <Text fontSize={'9.5pt'} fontWeight={'bold'}>
                              {lastName}
                            </Text>
                          )}

                          {/* 国名 */}
                          <Text fontSize={'7pt'} color={'GrayText'}>
                            {country || 'なし'}
                          </Text>
                        </>
                      );
                    })()}
                  </Td>
                  {Object.entries(sd).map((row, i) => {
                    const kiroku = row[1];
                    const point = calcHeptathlonPointToJSX(row[0], row[1]);
                    const BestData =
                      title === 'Pred. Rank(SB)'
                        ? differenceCsbData
                        : title === 'Pred. Rank(PB)'
                        ? differenceCpbData
                        : showData;

                    const differenceData = BestData.find(
                      (obj) => obj.name === sd.name
                    );

                    const totalData = Number(differenceData?.total)
                      ? Number(differenceData?.total)
                      : 0;
                    const difference = Number(sd.total) - totalData;
                    const differenceColor =
                      difference >= 0 ? '#ff7f50' : '#87cefa';
                    if (row[0] === 'name') {
                      return null;
                    }
                    return (
                      <Td key={i} textAlign={'center'}>
                        {shownResultEn(kiroku, row[0])}
                        {row[0] !== 'name' ? <br /> : <></>}
                        {row[0] === 'total' ? (
                          <>
                            {title === 'Result' ||
                            title === 'SB Rank' ||
                            title === 'PB Rank' ||
                            title === 'Potential SB' ||
                            title === 'Potential PB' ? null : (
                              <Text color={differenceColor}>
                                {difference > 0
                                  ? '+' + difference
                                  : difference === 0
                                  ? '±0'
                                  : difference}
                              </Text>
                            )}
                          </>
                        ) : (
                          <>{point}</>
                        )}
                      </Td>
                    );
                  })}
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableContainer>
    </>
  );
};
